import { render, staticRenderFns } from "./UpdateLabManager.vue?vue&type=template&id=dc06515e&scoped=true&"
import script from "./UpdateLabManager.vue?vue&type=script&lang=js&"
export * from "./UpdateLabManager.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLabManager.vue?vue&type=style&index=0&id=dc06515e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06515e",
  null
  
)

export default component.exports